import { get } from 'lodash'

const firedEventsMap = new Set()

/**
 * Use JS to manually obtain Optimizely's campaignFlags value.
 * Scenario example:
 * When the user manually clicks the cancel button, the random value of Optimizely is triggered at this time, accurately calculating the total number of samples of Optimizely.
 * @param config
 * @returns {(function(): Promise<void>)|*}
 * example: createOnceCampaignSyncHandler({
 *   eventName: 'billing-cancel-plan-zva-cancel-support',
 *   flagPath: 'campaignFlags.enableLiveChatWithCancelReasons',
 * })
 */
/* eslint-disable */
function createOnceCampaignSyncHandler(config) {
  return async function () {
    if (firedEventsMap.has(config.eventName)) return
    firedEventsMap.add(config.eventName)
    const event = new CustomEvent(config.eventName)
    window.dispatchEvent(event)
    await Promise.resolve()
    const value = get(window, config.flagPath, false)
    return value
  }
}

export const handleWinBackOptimizely = createOnceCampaignSyncHandler({
  eventName: 'opc-win-back-in-free-to-paid',
  flagPath: 'campaignFlags.enableOpcWinBackInFreeToPaid',
});
